import type { CoachingScope } from "@healthos/client-data";
import { CARE_WORDS, type CareKind, type CareWords } from "@healthos/shared";
import { createContext, useContext } from "react";

/** The words the coaching pages speak, set by the page from the programme's kind. */
export const CareWordsContext = createContext<CareWords>(CARE_WORDS.coaching);

export const useCareWords = () => useContext(CareWordsContext);

/** Which of the member's programmes a page is about: coaching, or their care team. */
export const ProgrammeKindContext = createContext<CareKind>("coaching");

/** A coach's coachee when given, otherwise the member's own programme of the page's kind. */
export function useCoachingScope(coacheeId?: string): CoachingScope {
  const kind = useContext(ProgrammeKindContext);
  return coacheeId ?? { kind };
}

export const useProgrammeKind = () => useContext(ProgrammeKindContext);
